"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberLog',
  props: {
    memberData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    // 获取日志数据
    fetchLogData: function () {
      var _fetchLogData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.memberData || !this.memberData.id)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              this.loading = true;
              _context.prev = 2;
              params = {
                userId: this.memberData.id,
                page: this.currentPage,
                limit: this.pageSize
              };
              _context.next = 3;
              return (0, _memberManagement.xyUserActionPage)(params);
            case 3:
              response = _context.sent;
              if (response && response.code === 200) {
                // 根据后端返回结构调整
                this.tableData = response.data && response.data.records || response.records || [];
                this.total = response.data && response.data.total || response.total || 0;
              } else {
                this.tableData = [];
                this.total = 0;
              }
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('获取日志数据失败:', _t);
              this.$message.error('获取日志数据失败');
              this.tableData = [];
              this.total = 0;
            case 5:
              _context.prev = 5;
              this.loading = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchLogData() {
        return _fetchLogData.apply(this, arguments);
      }
      return fetchLogData;
    }(),
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchLogData();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchLogData();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取操作类型文本
    getActionTypeText: function getActionTypeText(action) {
      var actionMap = {
        'BIND': '绑定微信',
        'UNCARD': '解绑卡号',
        'UNOPENID': '解绑openid',
        'UNBIND': '解绑微信'
      };
      return actionMap[action] || action || '未知操作';
    },
    // 解析ext内容（JSON格式）
    parseExtContent: function parseExtContent(ext) {
      if (!ext) return null;
      try {
        // 尝试解析JSON
        var parsed = JSON.parse(ext);
        // 如果是对象，返回解析结果
        if ((0, _typeof2.default)(parsed) === 'object' && parsed !== null) {
          return parsed;
        }
        // 如果不是对象，返回null让原始内容显示
        return null;
      } catch (error) {
        // JSON解析失败，返回null让原始内容显示
        return null;
      }
    }
  },
  mounted: function mounted() {
    this.fetchLogData();
  },
  watch: {
    // 监听会员数据变化，重新获取日志
    memberData: {
      handler: function handler(newVal) {
        if (newVal && newVal.userId) {
          this.currentPage = 1;
          this.fetchLogData();
        }
      },
      deep: true
    }
  }
};